module.exports = __webpack_public_path__ + "static/media/Cats eyes 03_TYSKA-mixdown.7bcad6de.mp3";